<!-- eslint-disable max-lines -->
<template>
    <paper v-loading="btnloading" class="mip-iframe" v-if="hasAuthorized">
        <div class="top-box">
            <!-- 按钮区域 -->
            <div class="detail-toolBar">
                <lots-button type="primary"
                    v-if="detailDataLocal.mipStatus ? ![2, 3, 4, 7].includes(+detailDataLocal.mipStatus) : true"
                    :loading="saveLoading" @click="handleSave">保存
                </lots-button>
                <el-tooltip class="item-flow-right" effect="dark" content="刷新" placement="bottom">
                    <lots-button size="mini" icon="el-icon-refresh" class="refresh" @click="refleshPage()"
                        :loading="detailLoading">
                    </lots-button>
                </el-tooltip>
            </div>
        </div>
        <div class="registraction-flow-form" v-loading="detailLoading">
            <!-- 表单区域 -->
            <collapse-infos ref="upholdHealder" :detailData="detailDataLocal" :collapse="COLLAPSE"
                :activeCollapses="activeCollapses" @change="handleInfosChange">
                <!-- 折叠筐标题插槽 -->
                <template v-slot:collapse-title-append="{ collapseItem }">
                    <span>{{ collapseItem.title }}</span>
                </template>
                <!-- 表单字段插槽 -->
                <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                    <span v-if="itemSetting.prop === 'relatedFiles'">
                        <lots-upload-button :text="'上传附件'" :bucket="'annto-lcrm'"
                            :disabled="['3', '4'].includes(detailDataLocal.mipStatus + '')"
                            @callback="(data) => { upLoadData(form, itemSetting, data); }">
                        </lots-upload-button>
                        <div class="file-infos">
                            <template v-if="form[itemSetting.prop]
                                && form[itemSetting.prop].length">
                                <div class="file-list" v-for="(item, index) in form[itemSetting.prop]"
                                    :key="index + item.fileName">
                                    <div class="file-name upload" :title="item.fileName">
                                        {{ `${index + 1}. ` }}
                                        <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
                                    </div>
                                    <div class="delete-btn">
                                        <el-button type="text" plain @click="handlePreview(item)">
                                            预览
                                        </el-button>
                                        <el-button type="text" plain>
                                            <a :href="item.fileUrl" target="_blank">下载</a>
                                        </el-button>
                                        <el-button type="text"
                                            :disabled="['3', '4'].includes(detailDataLocal.mipStatus + '')" plain
                                            @click="handleDeleteFile(form, itemSetting, index)">删除</el-button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </span>
                    <span v-else-if="itemSetting.prop === 'referenceFile'">
                        <div class="file-infos">
                            <template v-if="dictDatas[itemSetting.dictKey]">
                                <!-- <el-button
                                    type="text"
                                    plain
                                    @click="handleDownload('ALL', '参考附件模板.zip')">
                                    下载全部
                                </el-button> -->
                                <div class="file-list" v-for="(value, key, index) in dictDatas[itemSetting.dictKey]"
                                    :key="key">
                                    <div class="file-name" :title="value">
                                        {{ `${index + 1}. ` }}
                                        {{ value }}
                                    </div>
                                    <div class="delete-btn">
                                        <el-button type="text" plain @click="handleDownload(key, value)">
                                            下载
                                        </el-button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </span>
                    <div v-else-if="itemSetting.prop === 'registractionList'">
                        <div class="resistr-add">
                            <lots-button type="primary" v-if="regRulesShow['addBtn']"
                                @click="changeData">新建记录</lots-button>
                            <lotsButton icon="el-icon-delete" type="primary" size="mini" title="删除"
                                :disabled="!(detailDataLocal.renewalList && detailDataLocal.renewalList.length)"
                                v-if="regRulesShow['addBtn']" @click="handleDelete">删除
                            </lotsButton>
                        </div>
                        <edit-table-box ref="editTableBox" :selection="true" :control="regRulesShow['addBtn']"
                            :height="280" :allowRowClick="false" :tableData="detailDataLocal.renewalList"
                            :columns="newTableConfig.columns" :actions="newTableConfig.actions"
                            @selection-change="handleSelectedRow" @btn-event="actionClick">
                            <template #col-append="{ item, row, rIndex }">
                                <span v-if="item.prop === 'calCustomerLevel'">{{ codesToNames(row[item.prop],
                                    dictDatas[item.optionsKey]) }}</span>
                                <span v-else-if="item.prop === 'businessType'">{{ codesToNames(row[item.prop],
                                    dictDatas[item.optionsKey]) }}</span>
                                <span v-else-if="item.prop === 'warehouseType'">{{ codesToNames(row[item.prop],
                                    dictDatas[item.optionsKey]) }}</span>
                                <span v-else-if="item.prop === 'renewalRisk'"
                                    :class="[['1'].includes(row[item.prop] + '') ? 'red-color' : '']">
                                    {{ codesToNames(row[item.prop], dictDatas[item.optionsKey]) }}
                                </span>
                                <span v-else-if="item.prop === 'riskCause'">{{ codesToNames(row[item.prop],
                                    dictDatas[item.optionsKey]) }}</span>
                                <lots-button v-else-if="item.prop === 'file'" type="text"
                                    @click.stop="handleOpen(row)">查看附件</lots-button>
                            </template>
                        </edit-table-box>
                    </div>
                    <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                        {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--' }}
                    </span>

                </template>
            </collapse-infos>

            <!-- iflow区域 -->
            <el-collapse v-if="detailDataLocal.mipId" class="contract-collapse detail-more-collapse" value="mipInfo">
                <el-collapse-item title="流程信息" name="mipInfo">
                    <div class="header-operation">
                        <lots-button size="mini" type="primary" v-if="!['7'].includes(detailDataLocal.mipStatus + '')"
                            @click="submitMip" :loading="btnloading">
                            mip提交
                        </lots-button>
                    </div>
                    <iframe class="ifr" :src="mipUrl" v-if="!btnloading" />
                </el-collapse-item>
            </el-collapse>
        </div>
        <add-file-dialog v-if="addFileVisible" :fileReadonly="true" @confirm="addFileVisible = false"  :row="theRow" @handleClose="addFileVisible = false">
        </add-file-dialog>
        <!-- <advance-multi-dialog
            ref="advanceMultiDialog"
            @confirm="registractionSaveSure">
        </advance-multi-dialog> -->
        <tableMutiAdvanceDialog ref="advanceDialogRef" @confirm="(data, config) => addRegistractionSure(data, config)">
            <template #col-append="{ col, row, rIndex }">
                <span v-if="col.prop === 'calCustomerLevel'">{{ codesToNames(row[col.prop], dictDatas[col.optionsKey])
                }}</span>
                <span v-else-if="col.prop === 'businessType'">{{ codesToNames(row[col.prop], dictDatas[col.optionsKey])
                }}</span>
                <span v-else-if="col.prop === 'warehouseType'">{{ codesToNames(row[col.prop], dictDatas[col.optionsKey])
                }}</span>
                <span v-else-if="col.prop === 'renewalRisk'">{{ codesToNames(row[col.prop], dictDatas[col.optionsKey])
                }}</span>
                <span v-else-if="col.prop === 'riskCause'">{{ codesToNames(row[col.prop], dictDatas[col.optionsKey])
                }}</span>
                <lots-button v-else-if="col.prop === 'file'" type="text"
                    @click.stop="handleOpen(row)">查看附件</lots-button>
            </template>
        </tableMutiAdvanceDialog>
    </paper>
    <div class="no-auth-reg" v-else>{{ detailLoading ? '' : "抱歉，您暂时无权查看" }}</div>
</template>

<script>
import { ref, watch, computed, getCurrentInstance, onMounted, onActivated } from '@vue/composition-api';
import paper from '@/components/core/Paper.vue';
import lotsButton from '@/components/lots/lotsButton';
import CollapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import editTableBox from '@/components/lots/editTableBox/Index';
import addFileDialog from '@/modules/mdm/views/contractModules/components/addFileDialog/Index';
import {
    saveExitRegistration,
    getExitRegistration,
    registraionFileDownload
} from '@mdm/api/contractManage/contractRegistration.js';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
import {
    getAuthorByProcessIdApi
} from '@mdm/api/contractManage/mipIframeApi.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { Message, MessageBox } from 'element-ui';
import store from '@/store/index';
import utils from '@/components/utils/common.js';
import { collapse } from './collapseInfosConfig.js';
import _ from 'lodash';
import configurl from '@/config/user.env';
import { tableConfig, remarkText } from './config.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
// import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import tableMutiAdvanceDialog from '@/modules/mdm/views/contractModules/components/tableMutiAdvanceDialog/Index';
import { filePreview } from '@/utils/filePreview.js';
import Decimal from 'decimal.js';
const { MAGIC_NUMBER } = utils;
export default {
    name: 'strategicCooperationIntroduceApply',
    components: {
        paper,
        lotsButton,
        CollapseInfos,
        lotsUploadButton,
        editTableBox,
        addFileDialog,
        // advanceMultiDialog
        tableMutiAdvanceDialog
    },
    props: {
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => { }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = _.cloneDeep(collapse);
        const newTableConfig = ref(_.cloneDeep(tableConfig));
        const detailLoading = ref(false);
        const btnloading = ref(false);
        const disabledFlag = ref(false);
        const code = ref('');
        const detailDataLocal = ref({
            mipId: '',
            relatedFiles: [], // 相关附件
            renewalList: []
        });
        const tableData = computed(() => {
            function getTableData(prop) {
                return detailDataLocal.value[prop];
            }
            return getTableData;
        });
        // * 1：草稿；
        // * 2：待审批；
        // * 3：审批中；
        // * 4：审批通过；
        // * 5：审批驳回；
        // * 6：撤回；
        // * 7：作废
        const regRulesShow = computed(() => {
            const { id, mipId } = detailDataLocal.value;
            return {
                'addBtn': !id || !mipId || ['1', '5', '6'].includes(detailDataLocal.value.mipStatus?.toString())
            };
        });
        const authority = store.getters.authority;
        // eslint-disable-next-line max-len
        const activeCollapses = ref(['qingshiInfo']);
        const mipUrl = ref('');
        const lodash = computed(() => { return _; });
        const COLLAPSE = computed(() => { // 配置项动态计算
            const { mipStatus } = detailDataLocal.value;
            config.forEach((v, i) => {
                v.formList.forEach((v2, i2) => {
                    if (v2.prop === 'renewalRemark') {
                        /**
                         * 数据字典：RENEWAL_AUDIT_STATUS
                         * 1：草稿；
                         * 2：待审批；
                         * 3：审批中；
                         * 4：审批通过；
                         * 5：审批驳回；
                         * 6：撤回；
                         * 7：作废
                        */
                        // eslint-disable-next-line max-nested-callbacks
                        v2.disabled = ['3', '4'].includes(mipStatus?.toString()); // 审批中、审批通过、
                    } else if (v2.prop === 'winningSupplierName') {
                        v2.type = ['3', '4'].includes(mipStatus?.toString()) ? 'custom' : 'input';
                    }
                });
            });
            return config;
        });
        const tableHeight = computed(() => {
            function getHeight(prop) {
                const length = detailDataLocal.value[prop].length;
                return length ? length * MAGIC_NUMBER.THIRTY_SIX + MAGIC_NUMBER.FOURTY_ONE + 1 + 'px' : MAGIC_NUMBER.FIFTY_ONE + 7 + MAGIC_NUMBER.FIFTY + 'px';
            }
            return getHeight;
        });
        // ...mapGetters(['user', 'visitedViews', 'currentTenant', 'applicationCode', 'authority']),
        const hasAuthorized = computed(() => {
            let flag = false;
            const theMenu = Array.isArray(authority) && authority.length
                ? authority.find(item => item.resourceName && item.resourceName.includes('合同模块')) : null;
            if (theMenu?.subResources?.length) {
                flag = theMenu.subResources.some(item => item.resourceName
                    && (item.resourceName.includes('合同LCRM流程审批页') || item.resourceCode === 'RE7051576253501440' || item.frontUrl === '/mipIframe'));
            }
            // 判断创建人也可以查看
            const isCreater = detailDataLocal.value.renewalGroupCode ? detailDataLocal.value.createUserCode === userCode : true;
            return detailDataLocal.value.renewalGroupCode ? (authorized.value || flag || isCreater) : true;
        });
        const codesToNames = computed(() => {
            function codeToName(codes, dictObj) {
                const names = [];
                const codesArr = codes ? codes.split(',') : [];
                if (codesArr && codesArr.length) {
                    codesArr.forEach((key) => {
                        if (dictObj && dictObj[key]) {
                            names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                        }
                    });
                }
                return names.join(',');
            };
            return codeToName;
        });
        const newMip = ref(false);
        const refleshPage = () => {
            if (isHandleEdit.value) {
                MessageBox.confirm(`你当可能存在编辑未保存的数据，刷新页面将覆盖编辑的数据，确认继续刷新？`, `注意：`, {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _initData();
                });
            } else {
                _initData();
            }
        };
        // 处理详情返回数据格式
        const formatData = (data) => {
            const newData = _.cloneDeep(data);
            !newData.relatedFiles && (newData.relatedFiles = []);
            return newData;
        };
        const dictDatas = ref({});
        const { userName, userCode } = store.getters.user;
        // eslint-disable-next-line complexity
        const _initData = async () => {
            const { renewalGroupCode } = ctx.$route.query;
            detailLoading.value = true;
            const res = await getDictDataApi({
                dictCodes: 'CONTRACT_RENEWAL_REGISTRATION,NEOCRM_CUSTOMER_LEVEL,SYS_BMS_BUSI_TYPE,CRM_CONTRACT_RENEWAL_RISK,NEOCRM_WH_TYPE,CRM_CONTRACT_RENEWAL_RISK,CRM_CONTRACT_RENEWAL_RISK_CAUSE'
            });
            dictDatas.value = res.data;
            if (renewalGroupCode) {
                await getExitRegistrationInfo();
                await getIflowhandlers(detailDataLocal.value.mipId);
            }
            detailLoading.value = false;
            handleInfosChange({ form: formatData(detailDataLocal.value) });
        };
        const currentAuth = ref(false);
        const isHandleEdit = ref(false);
        const handleInfosChange = async (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { itemSetting } = formObjData;
            // 监控表单是否编辑过
            isHandleEdit.value = Boolean(itemSetting);
            if (!itemSetting) { // 页面初始化、刷新时走：
                if (detailDataLocal.value.mipId) {
                    handleCreate(); // 渲染iflow流程
                    currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                }
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
            } else { // collapse组件编辑回调时走：
                const { relatedFiles } = detailDataLocal.value;
                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    { relatedFiles } // 保证插槽数据用最新的
                );
            }
            // detailDataLocal.value.mipStatus = '7';
        };
        const isShowBtnFlow = computed(() => {
            return currentAuth.value; // 审批通过 || 当前操作人 || 流程提交人
        });
        const authorized = ref(false);
        const getIflowhandlers = async (fdId) => {
            // if (env === 'ver') {
            //     authorized.value = true;
            //     return false;
            // }
            const authorityMips = [];
            // const publicPrarms = { fdId, loginName: store.getters.user.userCode };
            let res = null;
            res = await getAuthorByProcessIdApi({ fdProcessId: [fdId], loginName: store.getters.user.userCode });
            if (+res.code === 0 && res.data && res.data.length) {
                const theData = res.data.find(item => item.fdProcessId === fdId);
                authorized.value = theData?.reader;
            }
            if (ctx.$route.query.isToOtherPersons) { // 传阅人也可以查看
                authorityMips.push(ctx.$route.query.isToOtherPersons);
            }
            authorized.value = authorized.value || authorityMips.some(item => item.includes(store.getters.user.userCode));
        };
        const handleCreate = () => {
            mipUrl.value = '';
            mipUrl.value = `${configurl.iflowUrl}?fdId=${detailDataLocal.value.mipId}&fdTemplateKey=CRM_renew_to_quit&userCode=${userCode}&userName=${userName}`;
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            newMip.value && setTimeout(() => {
                const element = document.getElementsByClassName('registraction-flow-form')[0];
                if (element) {
                    element.scrollTo(0, MAGIC_NUMBER.SIX_HUNDRED);
                }
                newMip.value = false;
            }, MAGIC_NUMBER.FOUR_HUNDRED);
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        const timer = 1800;
        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const times = setTimeout(async () => {
                        getExitRegistrationInfo();
                        currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                        clearTimeout(times);
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { renewalGroupCode, mipId } = detailDataLocal.value;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                params.formParam.fdUrl = `${origin}${pathname}#/registractionFlow?renewalGroupCode=${renewalGroupCode}&fdId=${mipId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };
        // draft_submit分支处理
        const handleDraftSubmit = async (params) => {
            try {
                const saveRes = await handleSave(true);
                if (saveRes && +saveRes.code === 0) {
                    await handleApproveProcess(params);
                } else {
                    btnloading.value = false;
                }
            } catch (e) {
                btnloading.value = false;
            }
        };
        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            btnloading.value = true;
            const params = prepareApproveParams(event.data);
            const processParam = params.processParam || {};
            if (processParam.operationType === 'draft_submit' && isHandleEdit.value) {
                const data = checkSubmit();
                if (!data) {
                    btnloading.value = false;
                    return;
                };
                await handleDraftSubmit(params);
                handleApproveProcess(params);
                return;
            }
            handleApproveProcess(params);
        };
        // eslint-disable-next-line complexity
        const submitMip = async () => {
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
            content.frames && content.frames.length && content.frames[1]
                && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
        };
        const currentTime = ref('');
        const handleEdit = () => {
            // eslint-disable-next-line max-len
            activeCollapses.value = ['basicInfo', 'gaikuangInfo', 'shiyongInfo', 'kehuJingyingInfo', 'kehuZhuanxingInfo', 'kehuHezuoInfo', 'qingshiInfo', 'qudaoInfo', 'pinleiInfo', 'dailiInfo', 'relatedFileInfo', 'cankaoFileInfo', 'pingfenInfo'];
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
        };
        const saveLoading = ref(false);
        const checkSubmit = () => {
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            // const data = setupContext.refs.upholdHealder.localizeData;
            if (!data) return false;
            const { relatedFiles } = detailDataLocal.value;
            const params = { ...data, relatedFiles };
            if (!params.renewalList.length) {
                Message.warning('请添加至少一条续签记录');
                return false;
            }
            params.renewalIdList = params.renewalList.map(it => Number(it.id));
            delete params.renewalList;
            if ([2, 3, 4, 7].includes(+params.mipStatus)) {
                if ([2, 3, 4, 7].includes(+params.mipStatus)) {
                    Message.warning('流程为待审批/审批中/审批通过/作废时，不允许修改！');
                    return false;
                }
            }
            return data;
        };
        const handleSave = (mipSubmit = false) => {
            const data = checkSubmit();
            if (!data) return;
            const { relatedFiles } = detailDataLocal.value;
            const params = { ...data, relatedFiles };
            params.renewalIdList = params.renewalList.map(it => Number(it.id));
            delete params.renewalList;
            saveLoading.value = true;
            return saveExitRegistration(params).then(res => {
                if (+res.code === 0 && res.data) {
                    newMip.value = true;
                    isHandleEdit.value = false;
                    detailDataLocal.value.renewalGroupCode = res.data.renewalGroupCode;
                    if (mipSubmit === true) return; // 排除点击事件的event
                    Message.success('保存成功');
                    // 更新地址栏url参数
                    const { origin, pathname } = window.location;
                    window.location.assign(`${origin}${pathname}#/registractionFlow?renewalGroupCode=${detailDataLocal.value.renewalGroupCode}`);
                    refleshPage();
                }
            }).finally(() => { saveLoading.value = false; });
        };
        // eslint-disable-next-line complexity
        const upLoadData = async (form, itemSetting, data) => {
            const { prop } = itemSetting;
            form[prop] = form[prop] ? form[prop] : [];
            if (data && +data.code === 0) {
                form[prop].push({ fileName: data.data.name, fileUrl: data.data.downUrl });
                const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
                if (prop === 'relatedFiles') {
                    if (itemSetting.rule[0].required) {
                        const targetRef = formRefs.find(item => item._props.refName === 'qingshiForm');
                        targetRef.$refs['qingshiForm'].validateField(prop);
                    }
                    detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
                    isHandleEdit.value = true;
                }
            }
        };
        const handleDeleteFile = (form, itemSetting, index) => {
            const { prop } = itemSetting;
            form[prop].splice(index, 1);
            detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
            const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
            if (prop === 'relatedFiles' && itemSetting.rule[0].required) {
                const targetRef = formRefs.find(item => item._props.refName === 'qingshiForm');
                targetRef.$refs['qingshiForm'].validateField(prop);
            }
            isHandleEdit.value = true;
        };
        const handleDownload = (code, fileName) => {
            registraionFileDownload({ code, fileName }).then(res => {
                try {
                    return JSON.parse(res); // 是 JSON 对象
                } catch (e) {
                    Message.success('下载成功');
                }
            });
        };
        const addFileVisible = ref(false);
        const theRow = ref({});
        const handleOpen = (row) => {
            theRow.value = row;
            addFileVisible.value = true;
        };
        const tableKey = ref(false);
        const actionClick = (row, event, index) => {
            /* eslint-disable indent */
            switch (event) {
                case 'del':
                    delAction(row);
                    break;
                default:
                    break;
            }
        };
        const delAction = row => {
            isHandleEdit.value = true;
            detailDataLocal.value.renewalList = detailDataLocal.value.renewalList.filter(it => it.id !== row.id);
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value); // 刷新表单子组件
            detailDataLocal.value.renewalGroupCode && handleSave();
        };
        const submitFlowLoading = ref(false);
        const getExitRegistrationInfo = () => {
            const renewalGroupCode = ctx.$route.query.renewalGroupCode || detailDataLocal.value.renewalGroupCode;
            if (!renewalGroupCode) return;
            btnloading.value = true;
            return getExitRegistration({
                renewalGroupCode: renewalGroupCode
            }).then(res => {
                if (res && +res.code === 0) {
                    detailDataLocal.value = res.data;
                    detailDataLocal.value.renewalList = detailDataLocal.value.renewalList?.map(it => {
                        it.allowEdit = false;
                        it.edit = -3;
                        if (!_.isNil(it.contractScale) && it.contractScale !== '') {
                            it.contractScale = Decimal(it.contractScale).toFixed(2);
                        }
                        return it;
                    }) || [];
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value); // 刷新表单子组件
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.fileUrl,
                fileName: row.fileName
            });
        };
        // const registractionSaveSure = async (data) => {
        //     const list = data.map(it => {
        //         it.flowCode = detailDataLocal.value.flowCode;
        //         return it;
        //     });
        //     filePreview(list).then(res => {
        //         if (res && +res.code === 0) {
        //             Message.success('添加成功');
        //         }
        //     }).finally(() => {
        //         // detailList.getList();
        //     });
        // };

        const addRegistractionSure = async (data = {}, config) => {
            const keys = Object.keys(data);
            const values = keys.map(key => data[key].split('|-,'));
            // 构建对象数组
            const result = values[0].map((_, index) => {
                return keys.reduce((obj, key, i) => {
                    obj[key] = values[i][index];
                    if (['file', 'fileListCn'].includes(key)) {
                        obj['file'] = JSON.parse(obj['fileListCn']);
                    }
                    return obj;
                }, {});
            });
            // detailDataLocal.value.renewalList = _.uniqBy([...result, ...detailDataLocal.value.renewalList], 'id');
            const newRenewalList = [...result].map(it => {
                return {
                    ...it,
                    id: Number(it.id)
                };
            });
            isHandleEdit.value = true;
            detailDataLocal.value.renewalList = _.uniqBy(newRenewalList, 'id');
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value); // 刷新表单子组件
            detailDataLocal.value.renewalGroupCode && handleSave();
        };
        const changeData = () => {
            const _list = detailDataLocal.value.renewalList.map(it => {
                it.fileListCn = JSON.stringify(it.file || []);
                return it;
            });
            const advanceParams = _.cloneDeep(tableConfig.registractionAdvanceParams);
            setupContext.refs.advanceDialogRef.show(true, advanceParams, { includeFlowCode: detailDataLocal.value.renewalGroupCode }, '', _list);
        };
        const selectedRows = ref([]);
        const handleSelectedRow = (val) => {
            selectedRows.value = val;
        };
        const handleDelete = () => {
            if (!selectedRows.value.length) {
                Message.warning('请勾选要删除的数据');
                return false;
            };
            isHandleEdit.value = true;
            detailDataLocal.value.renewalList = _.differenceBy(detailDataLocal.value.renewalList, selectedRows.value, 'id');
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value); // 刷新表单子组件
            detailDataLocal.value.renewalGroupCode && handleSave();
        };
        onMounted(async () => {

        });
        onActivated(async () => {
            tableKey.value = !tableKey.value;
        });
        watch( // 注意：加了immediate: true的话，watch监听要在放在最后，否则报错涉及的调用方法找不到！
            () => ctx.$route,
            (newVal) => {
                if (newVal.name === 'registractionFlow') {
                    detailDataLocal.value = {
                        renewalRemark: remarkText
                    };
                    _initData();
                    if (ctx.$route.query.renewalGroupCode) {
                        detailDataLocal.value.renewalGroupCode = ctx.$route.query.renewalGroupCode;
                    }
                    const renewalList = store.getters.registrationReprotList.find(it => it.id === ctx.$route.query.uuid)?.list || [];
                    detailDataLocal.value.renewalList = renewalList.map((it, index) => {
                        it.allowEdit = false;
                        return it;
                    });
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            config,
            COLLAPSE,
            detailLoading,
            btnloading,
            disabledFlag,
            code,
            detailDataLocal,
            mipUrl,
            refleshPage,
            handleInfosChange,
            submitMip,
            handleEdit,
            handleSave,
            upLoadData,
            handleDeleteFile,
            activeCollapses,
            tableHeight,
            tableKey,
            saveLoading,
            lodash,
            tableData,
            handleDownload,
            actionClick,
            newTableConfig,
            hasAuthorized,
            codesToNames,
            dictDatas,
            submitFlowLoading,
            handleOpen,
            addFileVisible,
            theRow,
            handlePreview,
            isShowBtnFlow,
            changeData,
            // registractionSaveSure,
            addRegistractionSure,
            regRulesShow,
            handleDelete,
            handleSelectedRow
        };
    }
};
</script>
<style lang="less">
@scrollbarThumbColor: rgba(0, 0, 0, .2);
@scrollbarThumbColorHover: rgba(0, 0, 0, .4);

.mip-iframe {
    // overflow: auto;
    display: flex;
    flex-direction: column;

    .top-box {
        .header-box {
            width: 100%;

            h4 {
                text-align: center;
                font-size: 20px;
                margin: 0;
                color: #606266;
            }

            .header-info-crm {
                width: 100%;
                display: flex;
                font-size: 14px;
                border-bottom: 1px solid #dde0e6;
                margin-bottom: 10px;
                padding-bottom: 5px;

                .tips {
                    flex: 1;
                    // color: red;
                    color: #606266;
                    line-height: 20px;
                }

                .apply-info {
                    width: 200px;
                    line-height: 20px;
                    color: #606266;
                    margin-left: 10px;
                }
            }
        }

        .detail-toolBar {
            .item-flow-right {
                float: right;

                &.refresh {
                    margin-left: 10px;
                }
            }
        }
    }

    .registraction-flow-form {
        overflow: auto;

        .upload-demo {
            display: inline-block;
        }

        .down-mould-btn {
            margin-left: 5px;
        }

        .upload-tips {
            display: inline-block;
            margin-left: 10px;
            line-height: 28px;
            font-size: 12px;
            color: #606266;
        }

        .file-infos {
            width: 100%;
            padding: 0 10px 0 0;

            .file-list {
                width: 100%;
                padding: 2px 0 2px 4px;
                display: flex;

                // justify-content: space-between;
                .file-name {

                    // flex: 1;
                    &.upload {
                        width: 500px;
                    }

                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                }

                .view-btn,
                .delete-btn {
                    width: 200px;
                    display: flex;

                    a {
                        text-decoration: none;
                        color: #4285F5;
                    }

                    .el-button {
                        margin-left: 10px;
                    }

                    .el-button:focus,
                    .el-button:hover,
                    .el-button:active,
                    .el-button.is-disabled {
                        outline: none !important;
                        border-color: transparent !important;
                        /* 可选：如果要去除激活时的边框颜色变化 */
                    }
                }
            }
        }

        .el-collapse-item__content {
            padding-bottom: 5px;
        }

        .el-collapse-item__arrow {
            margin: 0 8px 0 5px;
        }

        .el-button.is-disabled.is-plain,
        .el-button.is-disabled.is-plain:focus,
        .el-button.is-disabled.is-plain:hover {
            border-color: #FFF;
        }

        .width-small {
            width: 340px;
        }

        .width-middle {
            width: 500px;
        }

        .width-large {
            width: 1200px;
        }

        .el-form-item--mini.el-form-item,
        .el-form-item--small.el-form-item {
            margin-bottom: 2px;
        }

        .el-col.el-col-23.form-item {
            .el-form-item.el-form-item--mini {
                margin-bottom: 18px;
            }
        }

        .el-collapse-item__header {
            height: 32px;
        }

        .detail-form-collapse {
            padding-right: 10px;
        }

        .score-config-item-box {
            .item-tittle {
                font-size: 14px;
                font-weight: 600;
                color: #606266;
                margin-left: 28px;
            }
        }

        .rating-score-list-box {
            .el-collapse {
                border-bottom: none;

                .el-collapse-item__header {
                    border-bottom: none;
                }

                .el-collapse-item__wrap {
                    border-bottom: none;
                }
            }
        }
    }

    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }

    .el-collapse-item__header {
        color: #606266;
        font-size: 14px;
        font-weight: 600;
    }

    .header-operation {
        margin-top: 10px;
    }

    .resistr-add {
        float: right;
        margin-bottom: 8px;
        margin-right: 8px;
    }
}

.no-auth-reg {
    font-size: 16px;
    padding: 20px;
    background: #fff;
    width: 100%;
}

.my-tooltip-box {
    width: 800px;
}
</style>
